<template>
  <div class="page_container myindex english_container">
    <myHeader :isDark="false" />
    <div class="hide_content">
      <p>
        Hirender seamlessly integrates audio-visual, media control, and
        multi-media display technologies, ensuring precise playback and control
        for immersive experiences. With its advanced timeline management,
        Hirender delivers ultra-high-resolution 4K/8K playback, adaptive
        streaming, and low-latency playback, making it ideal for live events,
        exhibitions, and stage productions.
      </p>
      <p>
        Notably, Hirender has been at the core of major international events,
        such as the 2022 Beijing Winter Olympics and the 2023 Hangzhou Asian
        Games, ensuring flawless synchronization and multi-screen
        synchronization for engaging experiences. Its professional audio-visual
        solutions support event planners, corporate events, theater
        performances, and theme park attractions with cutting-edge AV solutions
        and real-time content rendering.
      </p>
      <p>
        hecoos – Your Partner in Virtual Production & Extended Reality As a
        world-leading xR creation platform, hecoos empowers film/TV production,
        live events, and immersive storytelling content through real-time
        shading, ray tracing, and volumetric video. The platform integrates
        virtual production, digital twin platform solutions, and AI-enhanced
        visuals, delivering next-generation event technology and AV solutions.
      </p>
      <p>
        hecoos has powered over 1,000+ high-profile projects, including the
        Shenzhen TV virtual production studio, where its virtual studio setup
        established an efficient workflow for dynamic content loading and
        broadcast content production. With its expertise in metaverse
        applications, haptic feedback integration, and blockchain-enabled
        content security, hecoos revolutionizes immersive art and spatial
        experiences.
      </p>
      <p>
        Advanced Projection Mapping & Multi-Media Server Solutions Hirender and
        hecoos provide industry-leading projection mapping, spherical
        projection, and auto-calibration for architectural visualization
        presentations, museum exhibitions, and retail displays. Utilizing
        naked-3D and extended reality technologies, they enhance corporate
        events, medical visualization projects, and automotive showroom
        displays.
      </p>
      <p>
        By integrating professional audio-visual systems with multi-media
        servers and cloud-based streaming, Hirender and hecoos ensure seamless
        remote control, primary backup mode reliability, and cross-platform
        compatibility. These innovations drive the future of event solutions,
        offering engaging experiences for annual meetings, concert visuals, and
        educational immersive sessions.
      </p>
      <p>
        With a commitment to tech innovation, Hirender and hecoos continue to
        push the boundaries of immersive storytelling, leveraging a third
        dimension, AR, and xR to deliver unparalleled interactive experiences
        across industries.
      </p>
      <p>Understanding Projection Mapping with hecoos Software</p>
      <p>
        Keywords: Projection Mapping, hecoos, 3D Model File, Blending
        Mode, Display Surface
      </p>
      <p>
        English Version: Projection mapping has revolutionized visual displays
        by transforming ordinary objects into dynamic canvases.
        With hecoos software, professionals can seamlessly integrate 3D Model
        Files into their projects, creating stunning visual experiences. The
        software's advanced Blending Mode ensures smooth transitions between
        multiple projectors, eliminating harsh edges and delivering a cohesive
        image.
      </p>
      <p>
        One standout feature is the Display Surface customization, allowing
        users to map content onto complex shapes like spheres or curved screens.
        Whether you're working on a Curved Screen or an LED Display Surface,
        hecoos provides precise control over every pixel. The Blending Edge
        AutoCalc function automatically calculates overlap areas, saving hours
        of manual adjustment.
      </p>
      <p>
        For large-scale installations, Cluster Render technology distributes the
        workload across multiple machines, maintaining high performance.
        The Camera Tracking feature synchronizes virtual and real-world
        elements, perfect for AR applications. With Real-time Fixture Sync,
        lighting effects stay perfectly aligned with projected content.
      </p>
      <p>Optimizing LED Screen Performances with hecoos</p>
      <p>
        Keywords: LED Screen, Pixel Positioning, Fixture Library, Brightness
        Analysis, Color Calibration
      </p>
      <p>
        English Version: Achieving flawless LED Screen performances requires
        precise Pixel Positioning and color management. hecoos software offers a
        comprehensive Fixture Library with pre-configured profiles for major LED
        brands, streamlining setup processes. The Brightness Analysis tool
        detects uneven illumination, while Color Calibration ensures consistent
        hues across panels.
      </p>
      <p>
        For creative control, the Color Wheel Setup lets designers fine-tune
        palettes, and the Alpha Channel support enables transparent overlays. In
        large venues, Screen Group Position adjustments align multiple screens
        effortlessly. The Grid Data feature assists in aligning irregular
        layouts, such as Brick Wall designs.
      </p>
      <p>
        English Version: The xR Extension technology in hecoos blends physical
        and virtual worlds seamlessly. By configuring Virtual Camera Set,
        producers can capture real-time actor performances against CGI
        backgrounds. The Tracking Device system, compatible with FreeD protocol,
        ensures millimeter-accurate alignment.
      </p>
      <p>
        For latency-sensitive applications, AR Low Latency Mode reduces delay to
        imperceptible levels. The software integrates with Notch for real-time
        particle effects, while Notch Vram Cleanup optimizes GPU memory. The xR
        Foreground Hemisphere creates immersive environments, and Camera-Card
        Association simplifies multi-camera setups.
      </p>
      <p>
        Key features like Mask Template and Chroma Key enable advanced
        compositing. The Render Cluster handles complex scenes, and Frame Sync
        Group maintains synchronization across devices. With NDI Streaming,
        content can be shared across networks effortlessly.
      </p>
      <p>Optimizing Your 3D Model File Workflow: Key Considerations</p>
      <p>
        In the dynamic realm of 3D design and visualization, efficient
        management of your 3D Model Files is paramount. First and foremost, pay
        attention to the Absolute Position and Absolute Offset settings. These
        parameters ensure that objects within your 3D scene are precisely
        located, which is crucial for a seamless and accurate visual
        representation.
      </p>
      <p>
        For example, when creating a complex architectural model, setting the
        correct Absolute Position for each component, like walls and furniture,
        makes the overall structure look realistic.
      </p>
      <p>
        Another important aspect is the use of Layers. Just as a painter uses
        different layers to build up a masterpiece, in 3D design, Layers allow
        you to organize and manage your model components separately. You can
        easily hide or show specific Layers during the design process, which
        streamlines your workflow and makes it easier to focus on different
        parts of the model.
      </p>
      <p>
        Animation also plays a significant role. Adding Animation to your 3D
        models can bring them to life. You can set up Keyframe animations to
        control the movement, rotation, and transformation of objects over time.
        For instance, in a product design showcase, Keyframe animations can be
        used to demonstrate how a product functions or how its parts move.
      </p>
      <p>
        When it comes to sharing and collaborating on your 3D projects, having a
        proper Account system is essential. Some platforms may
        require Account/PWD Required to ensure the security and integrity of
        your work. This way, only authorized users can access and modify your
        valuable 3D Model Files.
      </p>
      <p>
        In conclusion, by mastering these key elements such as 3D Model
        Files, Absolute Position, Layers, Animation, Keyframe,
        and Account management, you can optimize your 3D design workflow and
        create stunning, high - quality 3D models.
      </p>
    </div>
    <!-- 设计即实现模块 -->
    <div
      class="text-wrapper"
      :class="{ 'animate-shrink': shouldShrink, 'fade-out': isFadeOut }"
    >
      <div class="ss">
        <!-- <span class="char" v-show="showText" v-html="text" :class="{ 'fade-in-up': showText }">
        </span> -->
        <!--        <img v-show="showText" :class="{ 'fade-in-up': showText }"-->
        <!--          src="https://download.hecoos.com/enlightv/2025-20/79900826f556177de74c526a12aa93ed.png" alt="">-->
        <img
          v-show="showText"
          :class="{ 'fade-in-up': showText }"
          src="https://download.hecoos.com/enlightv/2025-23/ccd411742884dd8203ff4e2b80569fa9.png"
          alt=""
        />
      </div>
    </div>
    <!-- 虚拟制作模块 -->
    <div class="page-container">
      <video autoplay loop muted class="bg-video">
        <source
          src="https://download.hecoos.com/enlightv/2025-37/1e148a3d54641a6a75703a1922f8c229.mp4"
          type="video/mp4"
        />
        <!--        https://download.hecoos.com/enlightv/2025-10/d7123019592fe8567a54ba49371481fa.mp4-->
      </video>
    </div>

    <!-- hecoos studio 模块 -->
    <div class="index_container_2" ref="index_container_2">
      <div class="studio">
        <div class="hec wow fadeInUp commitTtemTitle">hecoos Studio</div>
        <div
          class="text1 wow fadeInUp commitTtemLevel2Title"
          style="line-height: normal"
        >
          Seamless Design to Execution
        </div>
      </div>
      <div class="container InedxflexCard">
        <div class="left-section clearfix">
          <ul class="sub-items">
            <li
              v-for="(item, index) in textList"
              :key="index"
              class="sub-item wow textAnimation"
              ref="textElement"
              @mouseenter="handleMouseEnter(index)"
              @mouseleave="handleMouseLeave(index)"
              :class="{ active: currentActive === index }"
            >
              {{ item.text }}
              <img
                v-show="item.isIconVisible"
                src="https://download.hecoos.com/enlightv/2025-28/4cc215357f35afd89965bc0822ae46fc.png"
                alt="蓝色图标"
                class="icon"
              />
            </li>
          </ul>
        </div>
        <div class="right-section">
          <div class="sectionCard">
            <div class="slide-up">
              <el-carousel
                ref="carousel"
                direction="vertical"
                :autoplay="false"
                height="378px"
                :initial-index="currentActive"
              >
                <el-carousel-item
                  v-for="(content, index) in contents"
                  :key="index"
                >
<!--                  <img-->
<!--                    :src="content.image"-->
<!--                    @click="handleClickStudioVideo(content)"-->
<!--                    alt="场景图"-->
<!--                    class="transition-img"-->
<!--                  />-->
                  <div class="transition_box" @click="handleClickStudioVideo(content)">
                    <video v-if="currentActive == index "  :ref="'videoRef_'+ index" class="transition-video" autoplay loop muted :src="content.cover_src"></video>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="flex-active">
              <div class="text-content">
                <p></p>
                <div class="buttons">
                  <button
                    class="free-trial-btn"
                    @click="handleClickStudioLink()"
                  >
                    FREE TRIAL
                  </button>
                  <button class="more-info-btn">
                    <router-link class="setting_a" to="/en/studio"
                      >LEARN MORE</router-link
                    >
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- hecoos xR/VP模块 -->
    <div class="hecoosxR-VP">
      <p class="wow fadeInUp commitTtemTitle">hecoos xR / VP</p>
      <div class="text4 wow fadeInUp commitTtemLevel2Title">
        Creating Boundless Visions Between <br />
        Reality and Imagination
      </div>
      <div class="flex-container">
        <div class="flex-container_right">
          <img
            src="https://download.hecoos.com/enlightv/2025-17/b47a0de71e01928151e04092b491d177.gif"
            alt=""
            srcset=""
            class="wow fadeInUp"
            style="border-radius: 20px"
          />
        </div>
        <div class="goKnow">
          <router-link
            class="router"
            to="/en/virtualProduction"
            style="display: block"
            >LEARN MORE</router-link
          >
        </div>
      </div>
    </div>
    <!-- hecoos Server模块 -->
    <div class="hecoosServer">
      <p class="wow fadeInUp commitTtemTitle">hecoos Server</p>
      <h1 class="gradient-text2 wow fadeInUp commitTtemLevel2Title">
        The Core of Live Control and Virtual Production
      </h1>
      <div class="media-server-wrapper">
        <video
          ref="hecoosVideo"
          src="https://download.hecoos.com/enlightv/2025-10/5041d9a4efe8822b28ec28af02b8213f.mp4"
          muted
        ></video>
      </div>

      <h1 class="main-title wow fadeInUp">Explore Our Hardware</h1>

      <div class="explore-product-wrap">
        <div
          class="product-block"
          v-for="(product, index) in products"
          :key="index"
        >
          <h2 :class="'productColor' + index">{{ product.name }}</h2>
          <p id="product-desc">{{ product.description }}</p>
          <!-- <button class="learn-more-btn"> -->
          <!-- 进一步了解 -->
          <router-link
            class="learn-more-btn"
            :to="{ path: product.url, hash: '#tab' }"
          >
            LEARN MORE
          </router-link>
          <!-- </button> -->
        </div>
      </div>
    </div>
    <!-- 视频教程模块 -->
    <div class="videoContent">
      <p style="margin-bottom: 35px" class="wow fadeInUp entitle1">
        <strong style="font-size: 72px" class="entitle1"
          >Video Tutorials</strong
        >
      </p>
      <p
        style="font-size: 36px; font-weight: 300; letter-spacing: 0.5px"
        class="wow fadeInUp"
      >
        Explore Videos
      </p>

      <div class="image-container">
        <div class="target-image wow fadeInUp">
          <p class="gradient-text entitle1">Embrace A New Workflow</p>
        </div>
        <router-link
          :to="{ name: 'enVideoTutorial', hash: '#specific-position' }"
          class="setting_a2"
        >
          <div class="play-button wow fadeInUp">
            <span class="play-icon"></span>
          </div>
        </router-link>
      </div>
    </div>
    <!-- Elfsight LinkedIn Feed | Untitled LinkedIn Feed -->
    <div class="linkedIn_wrap">
      <div class="linkedin_title entitle1">Linkedin</div>
      <div class="linkedin_title2">
        Follow hecoos Linkedin for the Latest News!
      </div>
      <div
        class="elfsight-app-aece7f42-505e-45e8-af53-928e56e90364"
        data-elfsight-app-lazy
      ></div>
    </div>

    <!-- 案例展示模块 -->
    <!-- <div class="caseShow">
      <p style="margin-bottom: 35px" class="wow fadeInUp">
        <strong style="font-size: 72px">SHOWCASES</strong>
      </p>
      <p
        style="font-size: 36px; font-weight: 300; letter-spacing: 0.5px"
        class="wow fadeInUp"
      >
        OUR LATEST UPDATES
      </p>
      <div class="imgBox">
        <myBanner3></myBanner3>
      </div>
      <p class="goLook">
        <router-link class="myBanner3_router" to="/en/casepresentation"
          >VIEW ALL CASES</router-link
        >
      </p>
    </div> -->
    <div class="caseShow">
      <p style="margin-bottom: 35px" class="font_f wow fadeInUp entitle1">
        Showcase
      </p>
      <p
        style="font-size: 36px; font-weight: 300; letter-spacing: 0.5px"
        class="wow fadeInUp"
      >
        Our Latest Updates
      </p>
      <div class="imgBox">
        <myBanner3
          v-if="bannerList.length"
          :bannerList="bannerList"
        ></myBanner3>
      </div>
      <router-link class="goLook" to="/en/casepresentation"
        >VIEW ALL CASES</router-link
      >
    </div>
    <!-- 听听他们怎么说模块 -->
    <!-- <myText></myText> -->
    <myFooter />
    <BackToTop />
    <floatingButton />
    <youtubeVideo v-if="youtubeVideoId" :youtubeVideoId.sync="youtubeVideoId"/>
  </div>
</template>

<script>
import myHeader from "@/components/en_pc/myHeader";
import myFooter from "@/components/en_pc/myFooter";
import myText from "@/components/en_pc/myText";
import myBanner3 from "@/components/en_pc/myBanner3";
import BackToTop from "@/components/en_pc/BackToTop";
import floatingButton from "@/components/en_pc/floatingButton";
import youtubeVideo from "@/components/en_pc/youtubeVideo";
import { getCaseList, getCaseClassificationList } from "@/api/api";
import { mapState } from "vuex";
export default {
  name: "Index",
  data() {
    return {
      shouldShrink: false,
      text: `WHERE DESIGN BECOMES REALITY`,
      showText: false,
      isVisible: false,
      isInView: false,
      currentActive: 0,
      textList: [
        { text: "3D PREVISUALIZATION", isIconVisible: false },
        { text: "PROJECTION SIMULATION", isIconVisible: false },
        {
          text: "LIGHTING PROGRAMMING",
          isIconVisible: false,
        },
        { text: "BROADCAST CONTROL", isIconVisible: false },
        { text: "LIVE CONTROL", isIconVisible: false },
      ],
      products: [
        {
          name: "Server-D",
          color: "cyan",
          description:
            "Full Control from Creative Concept to Seamless Performance",
          url: "/en/mediaServer?section=0",
        },
        {
          name: "Server-C",
          color: "orange",
          description: "Key Hub in the Virtual Production Filming Process",
          url: "/en/mediaServer?section=1",
        },
        {
          name: "Server-R",
          color: "aquamarine",
          description:
            "Powerful Rendering Capabilities Empower Virtual Content Creators",
          url: "/en/mediaServer?section=2",
        },
      ],
      contents: [
        {
          image: "https://download.hecoos.com/enlightv/2025-17/8bbf80331a527e8237a0c31eba6f0716.png",
          cover_src:'https://download.hecoos.com/enlightv/2025-37/15b3df305c61518370563e930fd54af3.mp4',
          videoId:'lOEbkxsE424',
          description:
            "投影光路设计的hecoos以三维可视化界面预演完整的活动过程，精准模拟视频、灯光、机械、交互、导播等舞台元素，艺术家与工程师通过预演协作探讨并清晰确立演出方案的每一处细节，是提升现场执行效率与准确率的坚实保障。",
        },
        {
          image:  "https://download.hecoos.com/enlightv/2025-17/feeb83a7028748f0cca988764cec9059.png",
          cover_src:'https://download.hecoos.com/enlightv/2025-37/c2cd1d552a5031cbf4a22e972693eccb.mp4',
          videoId: 'r1hGusBsqE8',
          description: "灯光预演与预编程的详细介绍...",
        },
        {
          image:  "https://download.hecoos.com/enlightv/2025-17/0b5bb8b4d2dcb3c09d82418b80e4ac7f.png",
          cover_src:'https://download.hecoos.com/enlightv/2025-37/0b967f76493620130db8b2a506c96a30.mp4',
          videoId: 'rqAiKVDJ_Jc',
          description: "导播系统的详细介绍...",
        },
        {
          image:  "https://download.hecoos.com/enlightv/2025-17/e651fd8a1a39ac24cf9c68eb508e71fa.png",
          cover_src:'https://download.hecoos.com/enlightv/2025-37/3b79f2b3dffae5b3524b7b6864f36f5d.mp4',
          videoId: 'l0MLyvM0tro',
          description: "现场控制的详细介绍...",
        },
        {
          image:  "https://download.hecoos.com/enlightv/2025-17/6985a7fa955f06e6859fd3376a707ab1.png",
          cover_src:'https://download.hecoos.com/enlightv/2025-37/7d00672e0da4f7c97c06a943f9a8d7b1.mp4',
          videoId: '7dG6F7x46rM',
          description: "现场控制的详细介绍...",
        },
      ],

      observer: null,
      bannerList: [],
      wowInstance: null, // 用于存储wow实例
      isFadeOut: false, // 新增用于控制渐隐的标志
      youtubeVideoId:''
    };
  },
  created() {
    this.getCaseLists();
  },
  mounted() {
    this.showText = true;
    // 延迟1秒后开始让盒子变小，可按需调整延迟时间
    setTimeout(() => {
      this.shouldShrink = true;
    }, 1000);
    this.wowInstance = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 100, // 适当增加偏移量，确保元素进入视口一定距离后再触发
      mobile: true,
      live: true,
      resetAnimation: true,
      callback: function (box) {
        // 动画完成后移除wow类，避免重复触发
        setTimeout(() => {
          box.classList.remove("wow");
        }, 1000); // 延迟时间与动画时长保持一致
      },
    });
    this.wowInstance.init();
    window.addEventListener("scroll", this.handleScroll);

    const video = this.$refs.hecoosVideo;
    const options = {
      root: null,
      rootMargin: "0px",
      // 当视频显示一半时触发回调
      threshold: 0.5,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          video.currentTime = 0; // 重置视频播放进度
          video.play().catch((error) => {
            console.log("视频播放失败:", error);
          });
        } else {
          video.pause(); // 视频离开视口时暂停
        }
      });
    }, options);

    this.observer.observe(video);

    video.addEventListener("ended", () => {
      video.pause(); // 视频播放结束后定格
    });
    // 3.5 秒（3500 毫秒）后执行渐隐操作
    setTimeout(() => {
      this.isFadeOut = true;
    }, 3500);
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    const video = this.$refs.hecoosVideo;
    video.removeEventListener("ended", () => {
      video.pause();
    });
  },
  components: {
    myHeader,
    myFooter,
    myText,
    myBanner3,
    BackToTop,
    floatingButton,
    youtubeVideo
  },

  computed: {
    ...mapState(["adminUserInfo"]),
  },
  methods: {
    handleClickStudioVideo(content){
      this.youtubeVideoId = content.videoId
    },

    handleClickStudioLink() {
      if (this.adminUserInfo && this.adminUserInfo.id) {
        this.pageTransition("/en/personalCenter");
      } else {
        this.pageTransition("/en/register");
      }
    },
    handleMouseEnter(index) {
      this.textList[index].isIconVisible = true;
      this.currentActive = index;
      this.$refs.carousel.setActiveItem(index);
    },
    handleMouseLeave(index) {
      // 这里可以选择在鼠标离开时恢复默认显示，或者保持当前状态
      // 若要恢复默认显示：
      // this.currentActive = 0;
      this.textList[index].isIconVisible = false;
    },
    getCaseLists() {
      getCaseClassificationList().then((res) => {
        const postData = {
          page: "1",
          limit: "8",
          type: res.data[1].id,
        };
        getCaseList(postData).then((res) => {
          this.bannerList = res.data;
          this.bannerList.forEach((item) => {
            this.$set(item, "showTitle", false);
          });
        });
      });
    },
    pageTransition(url) {
      this.$router.push({
        path: url,
      });
    },
    handleScroll() {
      const elements = this.$refs.textElement;
      if (!elements || elements.length === 0) return;
      elements.forEach((el, index) => {
        if (!el) return;

        // 获取元素的位置信息
        const rect = el.getBoundingClientRect();
        // 元素顶部相对于视口顶部的距离
        if (rect.bottom < 600) {
          this.currentActive = index;
          this.$refs.carousel.setActiveItem(index);
        }
        // 当元素进入视口下半部分时激活
      });
      // 优化WOW动画重置逻辑
      // const wowElements = document.querySelectorAll(".wow, .animated");
      // wowElements.forEach((element) => {
      //   const elrect = element.getBoundingClientRect();
      //   console.log(elrect.top > window.innerHeight,'elrect.bottom < 0 || elrect.top > window.innerHeight')
      //   if (elrect.bottom < 0 || elrect.top > window.innerHeight) {
      //     // 移除所有动画相关类
      //     element.classList.remove("animated");
      //     ["fadeIn", "fadeInUp", "slideInLeft", "bounceIn"].forEach((anim) => {
      //       element.classList.remove(anim);
      //     });
      //     element.classList.add("wow");

      //     // 使用组件实例中保存的wowInstance
      //     if (this.wowInstance) {
      //       this.wowInstance.sync(); // 这里是修复的关键
      //     }
      //   }
      // });
    },
  },
  watch: {},
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/banner.scss";
@import "@/styles/optimize_adaptation.scss";
.myindex {
  background-color: #f0f1fa;
}
// 设计即实现模块css
.myindex {
  .fade-out {
    opacity: 0 !important;
    height: 0px !important;
  }
}
// .setting_a {
//   text-decoration: none;
//   color: #2a82e4;
// }

.setting_a1 {
  text-decoration: none;
  color: #fff;
}

.setting_a1:hover {
  text-decoration: none;
  color: #2a82e4;
}
</style>
<style>
.linkedIn_wrap {
  width: 100%;
  position: relative;
  min-height: 160px;
  padding: 120px 90px;
  background: #e8e8f1;
}
.linkedIn_wrap:before {
  /*position: absolute;*/
  /*left: 0;*/
  /*bottom: 6px;*/
  /*width: 100%;*/
  /*height: 30px;*/
  /*background: #fff;*/
  /* content: " ";*/
  /*z-index: 10000;*/
}
.linkedIn_wrap .linkedin_title {
  text-align: center;
  font-size: 72px;
  line-height: 60px;
  font-weight: 700;
  margin-bottom: 40px;
}
.linkedIn_wrap .linkedin_title2 {
  font-size: 36px;
  text-align: center;
  line-height: 60px;
  /* font-weight: 300; */
  margin-bottom: 40px;
}
.eFUpYn{
  max-width: 100% !important;
}
</style>
